function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TABLE_LIMITS } from '@/utils/constants';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './Pagination.module.scss';
import { ActionIcon, NativeSelect, Text } from '@mantine/core';
import Icon, { IconSizes } from './Icon';
function Pagination(_param) {
    var limit = _param.limit, page = _param.page, total = _param.total, setLimit = _param.setLimit, nextPage = _param.nextPage, previousPage = _param.previousPage, props = _object_without_properties(_param, [
        "limit",
        "page",
        "total",
        "setLimit",
        "nextPage",
        "previousPage"
    ]);
    var intl = useIntl();
    var pageCount = Math.ceil(total / limit);
    React.useEffect(function() {
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                previousPage();
            } else if (event.key === 'ArrowRight') {
                nextPage();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function() {
            return window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        nextPage,
        previousPage
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: styles.pagination
    }, props), {
        children: [
            setLimit == null ? null : /*#__PURE__*/ _jsx(NativeSelect, {
                size: "xs",
                variant: "outline",
                value: limit,
                onChange: function(e) {
                    return setLimit(parseInt(e.target.value));
                },
                children: TABLE_LIMITS.map(function(limit) {
                    return /*#__PURE__*/ _jsx("option", {
                        value: limit,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "5c+ZHb",
                            defaultMessage: "Show {limit}",
                            values: {
                                limit: limit
                            }
                        })
                    }, limit);
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: styles.pageCount,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "xhnYsq",
                    defaultMessage: "Page {page} of {pageCount}",
                    values: {
                        page: page + 1,
                        pageCount: pageCount
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.actionButtons,
                children: [
                    /*#__PURE__*/ _jsx(ActionIcon, {
                        "aria-label": intl.formatMessage({
                            id: "6TbqAD",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Previous Page"
                                }
                            ]
                        }),
                        onClick: function() {
                            return previousPage();
                        },
                        disabled: page === 0,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.SM,
                            icon: faArrowLeft
                        })
                    }),
                    /*#__PURE__*/ _jsx(ActionIcon, {
                        "aria-label": intl.formatMessage({
                            id: "uuLnK5",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Next Page"
                                }
                            ]
                        }),
                        onClick: function() {
                            return nextPage();
                        },
                        disabled: page === pageCount - 1,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.SM,
                            icon: faArrowRight
                        })
                    })
                ]
            })
        ]
    }));
}
export default /*#__PURE__*/ React.memo(Pagination);
